import { useEffect } from 'react';
import Button from '../../Components/Button';
import Footer from '../../Components/Footer';
import MediaBrowser from '../../Components/Main pages/Media';
import Navbar from '../../Components/Navbar';
import SearchSidebar from '../../Components/Search bars/Treesearch';
import Landingpage from '../Home/Landingpage';
import styles from './Speechespage.module.css';

export default function Speeches() {
  useEffect(() => {
    const origin = window.location.origin;
    const canonicalUrl = `${origin}/speeches`;

    // Browser tab title + Google result title candidate
    document.title = 'بیانات شهيد سيد حسن نصرالله| nasrollah.info';

    const setMeta = (name, content, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';

      let element = document.querySelector(
        `meta[${attribute}="${name}"]`
      );

      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }

      element.setAttribute('content', content);
    };

    setMeta(
      'description',
      'آرشیو بیانات، سخنرانی‌ها و پیام‌های شهيد سيد حسن نصرالله '
    );

    setMeta('robots', 'index, follow');

    // Open Graph: sharing previews on WhatsApp, Telegram, Facebook, etc.
    setMeta('og:title', 'بیانات شهيد سيد حسن نصرالله| nasrollah.info ', true);
    setMeta(
      'og:description',
      'آرشیو بیانات، سخنرانی‌ها و پیام‌های شهيد سيد حسن نصرالله.',
      true
    );
    setMeta('og:type', 'website', true);
    setMeta('og:url', canonicalUrl, true);
    setMeta('og:site_name', 'nasrollah.info', true);
    setMeta('og:locale', 'fa_IR', true);

    // Canonical: tells Google this is the preferred URL
    let canonical = document.querySelector('link[rel="canonical"]');

    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }

    canonical.setAttribute('href', canonicalUrl);

    // Basic structured data for the page
    let jsonLd = document.querySelector('#speeches-jsonld');

    if (!jsonLd) {
      jsonLd = document.createElement('script');
      jsonLd.id = 'speeches-jsonld';
      jsonLd.type = 'application/ld+json';
      document.head.appendChild(jsonLd);
    }

    jsonLd.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'بیانات',
      description:
        'آرشیو بیانات، سخنرانی‌ها و پیام‌های شهيد سيد حسن نصرالله .',
      url: canonicalUrl,
      inLanguage: 'fa-IR',
      isPartOf: {
        '@type': 'WebSite',
        name: 'nasrollah.info',
        url: origin
      }
    });

    return () => {
      document.querySelector('#speeches-jsonld')?.remove();
    };
  }, []);

    return(<>
    <Navbar />
    <Landingpage />

    <div className={styles.main}>
        <div className={styles.container}>
            <div className={styles.containerSpeeches}>
                <div className={styles.section}>
  <span className={styles.sectionSubtitle}>
    'سخنرانی‌ها و پیام‌ها'
  </span>
  <h1 className={styles.sectionTitle}>
    'بیانات'
  </h1>
</div>
            </div>
            <p className={styles.para}>در این بخش، سخنرانی‌های شهيد سيد حسن نصرالله را خواهید خواند این مجموعه شامل بیش از سه دهه (32 سال) سخنرانی‌های ایشان در حوزه‌های متنوعی همچون سیاست، دین، عرفان و مباحث اندیشه‌ای است. این سخنرانی‌ها که بخش مهمی از میراث فکری ایشان را تشکیل می‌دهد، در طول دوران تصدی ایشان به‌عنوان دبیرحزب الله ایراد شده و این مسیر تا زمان شهادت ایشان ادامه یافته است. مطالعه‌ی این متون، دریچه‌ای به سوی اندیشه‌ها و دغدغه‌های ایشان در طول سالیان متمادی فعالیتشان خواهد بود.</p>
            <Button />
        </div>
    </div>
    
    <div className={styles.container} >
        <div className={styles.bodyContent}>
            <SearchSidebar />

            <MediaBrowser />
        </div>
    </div>
    <Footer />
    </>);
}